<template>
	<v-layout row wrap justify-space-between>
		<detail-description
			v-for="detail in details"
			:key="detail.label"
			:icon="detail.icon"
			:label="detail.label"
			:description="detail.description">
		</detail-description>
	</v-layout>
</template>

<script>
import DetailDescription from './DetailDescription';

export default {
	components: {
		DetailDescription,
	},
	name: 'list-detail-description',
	props: {
		details: {
			type: Array,
			required: true,
		},
	},
};
</script>




// WEBPACK FOOTER //
// ListDetailDescription.vue?34cb0d95